var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 5.953 5.953",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M84 108h24v24H84z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 -22.423 -28.773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.25 112.5v15c0 .99-.39 1.935-1.095 2.648a3.76 3.76 0 0 1-2.655 1.102h-15a3.754 3.754 0 0 1-3.75-3.75v-6.75h9.435l-2.467 2.468a.755.755 0 0 0 0 1.064c.15.143.337.218.532.218a.77.77 0 0 0 .533-.218l3.75-3.75.044-.052c.023-.03.046-.06.06-.09a.3.3 0 0 0 .046-.09c0-.008.007-.008.007-.015.015-.045.03-.09.045-.143a.74.74 0 0 0-.202-.675l-3.75-3.75a.757.757 0 0 0-1.066 0 .757.757 0 0 0 0 1.066l2.476 2.467H84.75v-6.75c0-2.07 1.68-3.75 3.75-3.75h15c.99 0 1.935.39 2.648 1.095a3.76 3.76 0 0 1 1.102 2.655"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.455d79af3b663a08c266fec212f72ecc.svg";
export { ForwardRef as ReactComponent };